export default __webpack_public_path__ + "static/BergenMono-Regular-59422ef46e8fdd70aa32251c24b9c2fd.woff";